import React, { useEffect, useState, useRef } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ThemeProvider } from './components/WorkflowAI/contexts/ThemeContext';
import PremiumLandingPage from './components/PremiumStuff/layout/PremiumLandingPage.jsx';
import WorkflowAI from './components/WorkflowAI/WorkflowAI';
import PitchDeck from './components/PitchDeck/PitchDeck.jsx';
import AdminDashboard from './components/Admin/AdminDashboard.jsx';
import Pricing from './components/PremiumStuff/Pricing.jsx';
// import AcquireLandingPage from './components/Acquire/AcquireLandingPage.jsx';
// import BusinessListingsPage from './components/Acquire/BusinessListingsPage.jsx';
// import BusinessDetailPage from './components/Acquire/BusinessDetailPage.jsx';
// import InvestorProfile from './components/Acquire/InvestorProfile.js';
// import InvestorsDirectory from './components/Acquire/InvestorsDirectory.jsx';
// import SellBusinessPage from './components/Acquire/SellBusinessPage.jsx';
// import AcquireApp from './components/Acquire/AcquireApp.jsx';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

// Create browser router for standard routing
const router = createBrowserRouter([
  {
    path: "/",
    element: <PremiumLandingPage />,
  },
  {
    path: "/business-control-room",
    element: (
      <ProtectedRoute>
        <WorkflowAI />
      </ProtectedRoute>
    ),
  },
  {
    path: "/pitch-deck",
    element: <PitchDeck />,
  },
  {
    path: "/admin",
    element: <AdminDashboard />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
]);

function App() {
  const [originalTitle] = useState('Busin.US'); // Store the original title
  const intervalRef = useRef(null); // Ref to store the interval ID

  useEffect(() => {
    // Function to handle visibility change
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // User left the tab - start the looping sequence
        let step = 0;

        // Clear any existing interval
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }

        // Set the first part of the message immediately
        document.title = "You just lost";

        // Start the looping interval
        intervalRef.current = setInterval(() => {
          if (step % 2 === 0) {
            // Show "The game"
            document.title = "The game";
          } else {
            // Show "you just lost"
            document.title = "you just lost";
          }
          step++;
        }, 1000); // Change every second
      } else {
        // User returned to the tab
        // Clear the interval
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
        // Reset to original title
        document.title = originalTitle;
      }
    };

    // Add event listener for visibility change
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup function to remove event listener and clear interval
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      // Clear interval if it's running
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      // Reset title when component unmounts
      document.title = originalTitle;
    };
  }, [originalTitle]);

  return (
    <ErrorBoundary>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <AuthProvider>
          <div className="App">
            <ThemeProvider>
              <RouterProvider router={router} />
            </ThemeProvider>
          </div>
        </AuthProvider>
      </GoogleOAuthProvider>
    </ErrorBoundary>
  );
}

export default App;